import { render, staticRenderFns } from "./GeofenceAddEditView.vue?vue&type=template&id=52090146&scoped=true&"
import script from "./GeofenceAddEditView.vue?vue&type=script&lang=js&"
export * from "./GeofenceAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceAddEditView.vue?vue&type=style&index=0&id=52090146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52090146",
  null
  
)

export default component.exports